import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { Modal, ModalBody } from "reactstrap";

/* ⭐ MUI DATE PICKER */
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "../Common/DeleteModal";

const RatesList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [dateFilter, setDateFilter] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [viewItem, setViewItem] = useState(null);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const limit = 20;

    const loadRates = async () => {
        dispatch(loadingTrue());

        const offset = (page - 1) * limit;

        const res = await Handler({
            method: "get",
            // backend-la status true/false nu varudhu, adhunala res.status use panrom
            url: `/rate/list.php?limit=${limit}&offset=${offset}&search=${search}&effective_from=${dateFilter || ""}`
        });

        if (res?.success) {
            setData((res?.data || []).filter(r => Number(r.is_active) === 1));
            setTotal(res.total_count || res?.total || res?.pagination?.total_rows || 0);
        } else {
            setData([]);
            setTotal(0);
        }

        dispatch(loadingFalse());
    };

    useEffect(() => { loadRates(); }, [page, search, dateFilter]);

    return (
        <div className="page-card">

            <div className="page-header">
                <h4>Rates</h4>

                <div className="d-flex gap-2 align-items-center">
                    <div className="search-box">
                        <i className='bx bx-search'></i>
                        <input
                            placeholder="Search Customer, Vehicle or Lorry..."
                            value={search}
                            onChange={e => { setPage(1); setSearch(e.target.value) }}
                        />
                    </div>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Effective Date"
                            value={dateFilter ? dayjs(dateFilter) : null}
                            onChange={(newValue) => {
                                setPage(1);
                                setDateFilter(newValue ? newValue.format("YYYY-MM-DD") : "");
                            }}
                            slotProps={{
                                textField: {
                                    size: "small",
                                    className: "bg-white",
                                }
                            }}
                        />
                    </LocalizationProvider>
                </div>
            </div>

            <div className="table-wrap">
                <table className="table modern-table">
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th>Lorry Type</th>
                            <th>Vehicle No</th>
                            <th>Normal</th>
                            <th>Normal OT</th>
                            <th>Offz Hrs</th>
                            <th>Holiday</th>
                            {/* <th>GST</th> */}
                            {/* <th>Effective</th> */}
                            <th className="text-center">View</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data?.length === 0 ? (
                            <tr><td colSpan="10" className="text-center">No rates found</td></tr>
                        ) : data?.map(r => (
                            <tr key={r.id}>
                                <td>
                                    <div className="fw-semibold">{r.customer_name}</div>
                                    <small className="text-muted">{r.customer_code}</small>
                                </td>
                                <td>{r.lorry_type}</td>
                                <td>{r.vehicle_number || "N/A"}</td>
                                <td>${r.normal_hrs}</td>
                                <td>${r.normal_hrs_ot}</td>
                                <td>${r.after_office_hrs}</td>
                                <td>${r.holiday}</td>
                                {/* <td>{r.gst_percent}%</td> */}
                                {/* <td>{r.effective_from ? new Date(r.effective_from).toLocaleDateString() : "N/A"}</td> */}
                                <td className="text-center">
                                    <button className="icon-btn view" onClick={() => setViewItem(r)}>
                                        <i className='bx bx-show'></i>
                                    </button>
                                    {/* ⭐ EDIT BUTTON - Redirects to Edit Page */}
                                    <button
                                        className="icon-btn edit"
                                        title="Edit Rate"
                                        onClick={() => navigate(`/expenses/edit/${r.id}`)}
                                    >
                                        <i className='bx bx-edit-alt' style={{ color: '#ffc107' }}></i>
                                    </button>
                                    <button className="icon-btn text-danger ms-1" title="Delete Rate"
                                        onClick={() => setDeleteTarget(r)}>
                                        <i className='bx bx-trash'></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination
                page={page}
                total={total}
                limit={limit}
                onPrev={() => setPage(p => Math.max(1, p - 1))}
                onNext={() => setPage(p => p + 1)}
            />

            {/* ⭐ PREMIUM VIEW MODAL */}
            <Modal isOpen={!!viewItem} toggle={() => setViewItem(null)} centered size="lg" className="extraordinary-modal">
                <ModalBody className="p-0 overflow-hidden">
                    {/* Banner Section */}
                    <div className="modal-banner-premium">
                        <div className="banner-content">
                            <div className="customer-avatar">
                                {viewItem?.customer_name?.charAt(0)}
                            </div>
                            <div className="header-text ms-3">
                                <h3 className="fw-bold mb-0 text-white">{viewItem?.customer_name}</h3>
                                <span className="badge bg-glass mt-1">{viewItem?.customer_code}</span>
                            </div>
                        </div>
                        <button className="glass-close-btn" onClick={() => setViewItem(null)}>
                            <i className='bx bx-x'></i>
                        </button>
                    </div>

                    <div className="modal-content-body p-4">
                        {/* Header Info */}
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h5 className="text-uppercase tracking-wider text-muted small fw-bold">Vehicle Details</h5>
                                <div className="d-flex align-items-center gap-3">
                                    <span className="big-font fw-bold text-dark">{viewItem?.lorry_type}</span>
                                    <div className="vertical-divider"></div>
                                    <span className="big-font fw-bold text-primary">{viewItem?.vehicle_number || "N/A"}</span>
                                </div>
                            </div>
                            <div className="text-end">
                                <h5 className="text-uppercase tracking-wider text-muted small fw-bold">GST Rate</h5>
                                <span className="gst-badge">{viewItem?.gst_percent}% GST</span>
                            </div>
                        </div>

                        {/* Rates Grid Cards */}
                        <div className="row g-3">
                            {/* Normal Hours Card */}
                            <div className="col-md-3">
                                <div className="rate-card normal">
                                    <div className="card-icon"><i className='bx bx-sun'></i></div>
                                    <p>Normal Hours</p>
                                    <div className="price-tag">${viewItem?.normal_hrs}</div>
                                    <small>Per Trip / Hour</small>
                                </div>
                            </div>

                            {/* OT Hours Card */}
                            <div className="col-md-3">
                                <div className="rate-card ot">
                                    <div className="card-icon"><i className='bx bx-time-five'></i></div>
                                    <p>Normal OT</p>
                                    <div className="price-tag">${viewItem?.normal_hrs_ot}</div>
                                    <small>Overtime Rate</small>
                                </div>
                            </div>

                            {/* Office Hours Card */}
                            <div className="col-md-3">
                                <div className="rate-card office">
                                    <div className="card-icon"><i className='bx bx-buildings'></i></div>
                                    <p>After Office</p>
                                    <div className="price-tag">${viewItem?.after_office_hrs}</div>
                                    <small>Special Hours</small>
                                </div>
                            </div>

                            {/* After Office Hours Card */}
                            <div className="col-md-3">
                                <div className="rate-card office">
                                    <div className="card-icon"><i className='bx bx-buildings'></i></div>
                                    <p>After Office OT</p>
                                    <div className="price-tag">${viewItem?.offz_hrs_ot}</div>
                                    <small>Special Hours</small>
                                </div>
                            </div>

                            {/* Holiday Card */}
                            <div className="col-12">
                                <div className="rate-card holiday-primary">
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <div>
                                            <p className="mb-0">Public Holiday</p>
                                            <div className="price-tag-md">${viewItem?.holiday}</div>
                                        </div>
                                        <div className="divider-light"></div>
                                        <div>
                                            <p className="mb-0">Holiday OT</p>
                                            <div className="price-tag-md">${viewItem?.holiday_ot}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Effective Date Card */}
                            {/* <div className="col-md-6">
                                <div className="rate-card effective">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="card-icon-sm"><i className='bx bx-calendar-check'></i></div>
                                        <div>
                                            <p className="mb-0 small">Effective From</p>
                                            <div className="fw-bold text-dark fs-5">
                                                {viewItem?.effective_from ? new Date(viewItem?.effective_from).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : "N/A"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <DeleteModal
                isOpen={!!deleteTarget}
                toggle={() => setDeleteTarget(null)}
                title="Delete Price Rate"
                message={`Are you sure you want to delete price rate #${deleteTarget?.id || ''}?`}
                onConfirm={async () => {
                    if (!deleteTarget) return;
                    setDeleting(true);
                    dispatch(loadingTrue());
                    const res = await Handler({
                        method: "delete",
                        url: "/rate/delete.php",
                        data: { id: deleteTarget.id }
                    });
                    dispatch(loadingFalse());
                    setDeleting(false);
                    if (res?.success) {
                        setDeleteTarget(null);
                        toast.success(res?.message || "Price rate deleted successfully");
                        setData(prevData => prevData.filter(r => String(r.id) !== String(deleteTarget.id)));
                        loadRates();
                    } else {
                        setDeleteTarget(null);
                        toast.error(res?.message || "Failed to delete price rate");
                    }
                }}
                loading={deleting}
            />
        </div>
    );
};

export default RatesList;